<template>
  <div class="recharge-page">
    <van-notice-bar scrollable class="subtle-notice">
      温馨提示：直充优惠价，无分润。
    </van-notice-bar>
    <div class="info-section">
      <van-cell-group inset>
        <van-cell title="ICCID" :value="formatICCID(iccid)" />
      </van-cell-group>
    </div>

    <div class="package-section">
      <div class="section-title">
        <van-divider dashed>请选择充值套餐</van-divider>
      </div>
      <div class="package-grid">
        <div v-for="pkg in packages" :key="pkg.packageId"
          :class="['package-card', { active: selectedPackage === pkg.packageId }]"
          @click="selectPackage(pkg.packageId)">
          <!-- 套餐名称 -->
          <div class="package-title">{{ pkg.mobilePkName }}</div>
          <div class="main-price-row">
            <!-- <span class="sub-label">（微信支付）</span> -->
            <span class="main-price">¥{{ pkg.baseSettlePrice }}</span>
            <span class="original-price">¥{{showSalePrice(pkg)}}</span>
          </div>

          <!-- 流量信息 -->
          <div class="package-flow">{{ pkg.flow }}M</div>

          <!-- 选中图标 -->
          <van-icon v-if="selectedPackage === pkg.packageId" name="success" class="check-icon" />
        </div>
      </div>
    </div>

    <div class="submit-area">
      <div class="submit-content">
        <div class="total-amount">
          <van-row>
           <van-col span="24" class="label">
                 <span class="original-price">原价￥{{ showSalePrice(selectedPackageObj)  }}</span>
            </van-col>
            <van-col span="24" class="label">
               优惠价
                 <span class="price">￥{{ selectedPackageObj.baseSettlePrice}}</span>
                 <label class="labelTwo">
                   预存立减
                   <span class="priceTwo">-{{ selectedPackageObj.baseSettlePrice-showSettlePrice(selectedPackageObj)}}</span>
                 </label>
            </van-col>
            <van-col span="24" class="tips">
              <span>{{ validityString }}</span>
              <div class="van-ellipsis van-hairline--top">
                (预存)账户余额：<span>{{ showBalance?'￥'+balance:'***' }}</span>
                <van-icon :name="showBalance ? 'eye-o' : 'closed-eye'" class="toggle-password-icon"
                  @click="toggleBalanceVisibility" />
              </div>
            </van-col>
          </van-row>
        </div>
        <div class="button-container">
          <van-button type="info" size="large" @click="myRecharge" :disabled="!selectedPackage" class="recharge-button">
            预存支付￥{{ currentPrice }}
          </van-button>
          <span class="separator"></span>
          <van-button type="primary" size="large" @click="onRecharge" :disabled="!selectedPackage"
            class="recharge-button">
            微信支付￥{{ selectedPackageObj.baseSettlePrice }}
          </van-button>
        </div>
      </div>
    </div>
    <van-popup v-model="showPasswordPopup" round class="password-popup" :close-on-click-overlay="false">
      <div class="password-dialog">
        <h1 class="title">确认充值?</h1>
        <p class="description">
          预存支付：<b style="color: #ff0000;">¥{{ showSettlePrice(selectedPackageObj) }}</b><br><br>
          包含流量：{{ selectedPackageObj.flow }}M<br><br>
          {{ getFullValidityStringForPackage(selectedPackageObj) }}<br><br>
          支付方式：<span style="color: red;">预存支付</span><br><br>
          账户余额：<span style="color: #55aaff;">￥{{balance}}</span>
        </p>
        <div v-show="showLoading">
          <p class="popup-toast info">正在处理中...</p>
        </div>
        <div v-show="showLoading == false">
          <template v-if="balance>showSettlePrice(selectedPackageObj)">
            <p class="input-label">安全验证</p>
            <!-- 显示提示信息 -->
            <div class="password-input-wrapper">
              <input ref="passwordInput" v-model="password" :type="showPassword ? 'text' : 'password'"
                placeholder="请输入登录密码" class="custom-password-input" @focus="onPasswordFocus" @blur="onPasswordBlur" />
              <van-icon :name="showPassword ? 'eye-o' : 'closed-eye'" class="toggle-password-icon"
                @click="togglePasswordVisibility" />
            </div>
            <p v-show="popupToastMessage" class="popup-toast" :class="popupToastType">{{ popupToastMessage }}</p>
            <div class="actions" style="padding-top: 30px;">
              <van-button type="default" @click="cancelPasswordInput" size="small" plain>取消</van-button>
              <van-button type="info" @click="confirmPassword" size="small" plain>确认支付</van-button>
            </div>
          </template>
          <template v-else>
            <p class="popup-toast fail">预存账户余额不足，请返回首页 > 预存账户 进行预存。</p>
            <van-button type="default" @click="cancelPasswordInput" size="small" block>取消</van-button>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as api from '@/api/api.js'
import * as packageApi from '@/api/package.js'
import {
  infoAccount
} from '@/api/user.js'
import {
  chooseWXPay
} from '@/api/wxShare.js'
import {
  Toast
} from 'vant'
import { setLocalWithExpiry } from '@/utils/localStorageUtil'

export default {
  name: 'packageAdd', // 确保组件名与文件名一致
  data () {
    return {
      showLoading: false,
      showBalance: false,
      balance: '加载中...',
      iccid: '',
      orderCode: '',
      orderId: '',
      openid: '',
      czIndex: 0,
      selectedPackage: '', // 当前选中的套餐 value
      packages: [],
      password: '', // 存储输入的密码
      showPassword: false, // 控制密码显示/隐藏
      showPasswordPopup: false, // 控制密码弹窗显示
      popupToastMessage: '', // 弹窗内提示消息
      popupToastType: 'info' // 提示类型: info, success, fail
    }
  },
  computed: {
    // 获取当前选中的套餐对象，方便在模板中使用
    selectedPackageObj () {
      return this.packages.find(p => p.packageId === this.selectedPackage) || {}
    },
    // 计算当前选中套餐的价格
    currentPrice () {
      const pkg = this.packages.find(p => p.packageId === this.selectedPackage)
      return pkg ? this.showSettlePrice(pkg) : '0.00'
    },
    validityDescription () {
      const pkg = this.packages.find(p => p.packageId === this.selectedPackage)
      if (!pkg || !pkg.effectiveType || !pkg.effectiveTime) {
        return ''
      }

      const timeValue = parseInt(pkg.effectiveTime, 10)
      if (isNaN(timeValue) || timeValue <= 0) {
        return ''
      }

      switch (pkg.effectiveType) {
        case '01': // 按月份计算
          if (timeValue === 1) {
            return '1个月'
          } else if (timeValue % 12 === 0) {
            const years = timeValue / 12
            return `${years}年`
          } else {
            return `${timeValue}个月`
          }
        case '02': // 按天数计算
          if (timeValue === 1) {
            return '1天'
          } else {
            return `${timeValue}天`
          }
        default:
          console.warn('Unknown effective type for description:', pkg.effectiveType, pkg)
          return ''
      }
    },
    validityString () {
      const pkg = this.packages.find(p => p.packageId === this.selectedPackage)

      if (!this.packages || !Array.isArray(this.packages)) {
        console.warn('Packages data is not ready or not an array.')
        return ''
      }
      if (!this.selectedPackage) {
        return ''
      }
      if (!pkg) {
        console.warn(`Selected package with ID '${this.selectedPackage}' not found in packages list.`)
        return ''
      }
      if (!pkg.effectiveType || !pkg.effectiveTime) {
        console.warn('Selected package is missing effectiveType or effectiveTime:', pkg)
        return ''
      }
      if (pkg.effectiveType !== '01' && pkg.effectiveType !== '02') {
        console.warn('Unknown effective type for selected package:', pkg.effectiveType, pkg)
        return ''
      }
      const timeValue = parseInt(pkg.effectiveTime, 10)
      if (isNaN(timeValue) || timeValue <= 0) {
        console.warn('effectiveTime is not a valid positive number string:', pkg.effectiveTime, pkg)
        return ''
      }

      let durationDescription = ''
      switch (pkg.effectiveType) {
        case '01': // 按月
          if (timeValue === 1) {
            durationDescription = '1个月'
          } else if (timeValue % 12 === 0) {
            const years = timeValue / 12
            durationDescription = `${years}年`
          } else {
            durationDescription = `${timeValue}个月`
          }
          break
        case '02': // 按天
          if (timeValue === 1) {
            durationDescription = '1天'
          } else {
            durationDescription = `${timeValue}天`
          }
          break
      }

      const startDate = new Date()
      let endDate
      try {
        endDate = new Date(startDate)
        if (pkg.effectiveType === '01') {
          endDate.setMonth(endDate.getMonth() + timeValue)
          endDate.setDate(endDate.getDate() - 1)
        } else if (pkg.effectiveType === '02') {
          endDate.setDate(endDate.getDate() + timeValue - 1)
        }

        const formattedStartDate = this.formatDate(startDate)
        const formattedEndDate = this.formatDate(endDate)

        // return `有效期：${durationDescription} （${formattedStartDate} 至 ${formattedEndDate}）`
        return `生效日期：${formattedStartDate} 至 ${formattedEndDate} （共${durationDescription}）`
      } catch (error) {
        console.error('Error calculating validity period:', error, pkg)
        return ''
      }
    }
  },
  methods: {
    // 获取余额
    async infoAccount () {
      try {
        const {
          data: res
        } = await infoAccount({
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0]
        })
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login/no')
          return
        }
        this.balance = res.balance || '0.00'
      } catch (e) {
        console.error(e)
      }
    },
    toggleBalanceVisibility () {
      this.showBalance = !this.showBalance
      if (this.showBalance) {
        this.infoAccount()
      }
    },
    showSettlePrice (pkg) {
      return pkg.settlePrice > 0 ? pkg.settlePrice : (pkg.parentMaxSalePrice ? pkg.parentMaxSalePrice : pkg
        .baseSettlePrice)
    },
    showSalePrice (d) {
      return d.salePrice > 0 ? d.salePrice : (d.parentMaxSalePrice ? d.parentMaxSalePrice : d.baseSalePrice)
    },
    formatICCID (iccid) {
      if (!iccid) return ''
      const str = String(iccid)
      // 4位一分隔
      return str.match(/.{1,4}/g).join(' ')
    },
    getValidityDescriptionForPackage (pkg) {
      if (!pkg || !pkg.effectiveType || !pkg.effectiveTime) {
        return ''
      }

      const timeValue = parseInt(pkg.effectiveTime, 10)
      if (isNaN(timeValue) || timeValue <= 0) {
        return ''
      }

      switch (pkg.effectiveType) {
        case '01': // 按月
          if (timeValue === 1) {
            return '1个月'
          } else if (timeValue % 12 === 0) {
            const years = timeValue / 12
            return `${years}年`
          } else {
            return `${timeValue}个月`
          }
        case '02': // 按天
          if (timeValue === 1) {
            return '1天'
          } else {
            return `${timeValue}天`
          }
        default:
          console.warn('Unknown effective type for description:', pkg.effectiveType, pkg)
          return ''
      }
    },

    getFullValidityStringForPackage (pkg) {
      if (!pkg || !pkg.effectiveType || !pkg.effectiveTime) {
        return ''
      }
      const timeValue = parseInt(pkg.effectiveTime, 10)
      if (isNaN(timeValue) || timeValue <= 0) {
        return ''
      }

      const durationDesc = this.getValidityDescriptionForPackage(pkg)
      if (!durationDesc) return ''

      const startDate = new Date()
      let endDate

      try {
        endDate = new Date(startDate)
        if (pkg.effectiveType === '01') {
          endDate.setMonth(endDate.getMonth() + timeValue)
          endDate.setDate(endDate.getDate() - 1)
        } else if (pkg.effectiveType === '02') {
          endDate.setDate(endDate.getDate() + timeValue - 1)
        }

        const formattedStartDate = this.formatDate(startDate)
        const formattedEndDate = this.formatDate(endDate)

        // 使用方案一的格式
        return `有 效 期：${durationDesc} \n生效日期：${formattedStartDate} 至 ${formattedEndDate}`
      } catch (error) {
        console.error('Error calculating validity period for dialog:', error, pkg)
        return ''
      }
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，需要+1
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    goBack () {
      this.$router.back() // 返回上一页
    },
    selectPackage (value) {
      this.selectedPackage = value
    },
    /**  充值部分   */
    xfBtn (ress) {
      const that = this
      // 使用 import 进来的 chooseWXPay 函数
      chooseWXPay(ress.timeStamp, ress.nonceStr, ress.packageValue, ress.signType, ress.paySign, ress.appId)
        .then(res => {
          if (res.errMsg === 'chooseWXPay:ok') {
            that.$store.commit('setFlag', 'true')
            that.$router.push({
              name: 'Pay'
            })
          }
        })
        .catch(err => {
          if (err.errMsg === 'chooseWXPay:cancel') return Toast('用户取消支付')
          if (err.errMsg === 'fail') return Toast('支付失败')
        })
    },
    async updates (e) {
      if (e !== 'huoqu') {
        this.$store.commit('setOrder', '')
        this.$store.commit('setFindType', 'liuliang')
        // 使用 import 进来的 api 对象
        const {
          data: res
        } = await packageApi.agentRechargePackage({
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0],
          iccid: this.iccid,
          packageId: this.selectedPackage
        })
        if (res.code !== 0) {
          return Toast.fail(res.msg)
        }
        this.orderCode = res.extend.orderCode
        this.orderId = res.extend.pay.id
        this.$store.commit('setOrder', this.orderId)
      }
      // 使用 import 进来的 api 对象
      const {
        data: ress
      } = await api.payUnifiedOrderV2({
        payId: this.orderId,
        tradeType: 'JSAPI',
        openId: this.openid
      })
      if (ress.code !== 0) {
        return this.$toast(ress.msg) // 使用全局注册的 this.$toast
      }
      if (!ress.extend.payData) {
        return this.$toast('订单获取失败，请稍后重试') // 使用全局注册的 this.$toast
      }
      const payData = ress.extend.payData
      if ('payUrl' in payData) {
        setLocalWithExpiry('currentOrderCode', this.orderCode, 5) // 5分钟
        this.$toast.success('跳转支付页面...')
        window.location.href = payData.payUrl
        return
      } else if (!ress.appId || !ress.nonceStr || !ress.packageValue || !ress.paySign || !ress.signType || !ress
        .timeStamp) {
        if (this.czIndex > 4) {
          return Toast('支付失败，请稍后重试') // 使用 import 进来的 Toast
        }
        this.czIndex++
        return this.updates('huoqu')
      }
      this.xfBtn(ress)
    },
    myRecharge () {
      const pkg = this.packages.find(p => p.packageId === this.selectedPackage)
      if (!pkg) {
        this.showPopupToast('请选择一个套餐', 'fail')
        return
      }
      this.infoAccount() // 查余额
      // 显示弹窗
      this.showPasswordPopup = true
      this.password = '' // 打开时清空密码
      this.showPassword = false // 重置显示状态
      this.popupToastMessage = '' // 清除旧提示
      // 在 nextTick 后聚焦，确保 DOM 更新完成
      this.$nextTick(() => {
        if (this.$refs.passwordInput) {
          this.$refs.passwordInput.focus()
        }
      })
    },

    // 显示弹窗内提示
    showPopupToast (message, type = 'info') {
      this.popupToastMessage = message
      this.popupToastType = type
      // 3秒后自动清除提示
      setTimeout(() => {
        if (this.popupToastMessage === message) {
          this.popupToastMessage = ''
        }
      }, 3000)
    },

    onPasswordFocus () {
      // 可选：密码框获得焦点时的处理
      console.log('Password input focused')
    },

    onPasswordBlur () {
      // 可选：密码框失去焦点时的处理
      console.log('Password input blurred')
    },

    togglePasswordVisibility () {
      this.showPassword = !this.showPassword
    },

    cancelPasswordInput () {
      this.showPasswordPopup = false
      this.password = '' // 关闭时清空密码
      this.showPassword = false // 重置显示状态
      this.showPopupToast('已取消', 'info')
      // 延迟清除提示，让用户看到
      setTimeout(() => {
        if (this.popupToastType === 'info' && this.popupToastMessage === '已取消') {
          this.popupToastMessage = ''
        }
      }, 1500)
    },
    async confirmPassword () {
      if (!this.password) {
        this.showPopupToast('请输入登录密码', 'fail')
        return
      }

      this.showLoading = true

      try {
        const response = await packageApi.agentMethodRecharge({
          password: this.password,
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0],
          iccid: this.iccid,
          packageId: this.selectedPackage
        })

        if (response.data.code !== 0) {
          this.showPopupToast(response.data.msg || '操作失败', 'fail')
        } else {
          this.showPopupToast('充值成功', 'success')
          // 成功后延迟关闭弹窗
          setTimeout(() => {
            this.showPasswordPopup = false
            this.password = '' // 成功后清空密码
            this.showPassword = false // 重置显示状态
            this.goBack() // 返回上一页
          }, 1500)
        }
      } catch (error) {
        console.error('充值请求失败:', error)
        this.showPopupToast('网络错误或服务器异常，请稍后重试', 'fail')
      } finally {
        this.showLoading = false
      }
    },
    onRecharge () {
      const pkg = this.packages.find(p => p.packageId === this.selectedPackage)
      if (!pkg) {
        this.$toast('请选择一个套餐') // 添加一个提示
        return
      }
      const validityInfo = this.getFullValidityStringForPackage(pkg)

      let message = '优惠价：<b style="color: #ff0000;">¥' + pkg.baseSettlePrice + '</b>'
      message += `\n\n包含流量：${pkg.flow}M`
      if (validityInfo) {
        message += `\n\n${validityInfo}`
      }
      message += '\n\n支付方式：<span style="color: red;">微信支付</span>'

      this.$dialog.confirm({
        title: '确认充值？',
        confirmButtonText: '去支付',
        confirmButtonColor: '#07c160',
        message: message, // 使用构建好的消息
        messageAlign: 'left'
      })
        .then(() => {
          this.updates()
        })
        .catch(() => {
          this.$toast('已取消') // 使用全局注册的 this.$toast
        })
    },
    async profit () {
      this.openid = this.$store.state.openId ? this.$store.state.openId : ''
      // 使用 import 进来的 api 对象
      const {
        data: res1
      } = await packageApi.agentPackageList({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        iccid: this.iccid
      })
      this.packages = res1.extend.List
      // 默认选中第一个套餐 (移到这里，确保数据加载后执行)
      if (this.packages.length > 0 && !this.selectedPackage) {
        this.selectedPackage = this.packages[0].packageId
      }
    }
  },
  created () {
    const routeIccid = this.$route.params.iccid
    if (routeIccid) {
      this.iccid = routeIccid
      sessionStorage.setItem('packageAgent-currentIccid', routeIccid)
    } else {
      const storedIccid = sessionStorage.getItem('packageAgent-currentIccid')
      if (storedIccid) {
        this.iccid = storedIccid
      }
    }
    this.profit()
  },
  watch: {
    '$route.params.iccid' (newIccid) {
      if (newIccid) {
        this.iccid = newIccid
        sessionStorage.setItem('packageAgent-currentIccid', newIccid)
      }
    }
  }
}
</script>
<style lang="less" scoped>
  /* --- 移除 CSS 变量，直接使用具体值 (这部分保持不变) --- */

  .recharge-page {
    min-height: 100vh;
    background-color: #f8f9fa;
    /* 直接使用颜色值 */
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .info-section {
    margin-top: 16px;
    padding: 0 16px;
  }

  /* --- 强化 /deep/ 并提高优先级 (这部分保持不变) --- */
  .info-section ::v-deep .van-cell-group--inset {
    margin: 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  .info-section ::v-deep .van-cell {
    padding: 16px;
    background-color: #ffffff !important;
    /* 强制应用背景色 */
    color: #212529 !important;
    /* 强制应用文字色 */
  }

  .info-section ::v-deep .van-cell::after {
    border-bottom-color: #e9ecef !important;
    /* 强制应用边框色 */
  }

  .info-section ::v-deep .van-cell__title {
    color: #6c757d !important;
    /* 强制应用标题色 */
  }

  .info-section ::v-deep .van-cell__value {
    color: #212529 !important;
    /* 强制应用值色 */
    font-weight: 500;
  }

  .package-section {
    margin-top: 24px;
    margin-bottom: calc(80px + 32px);
    /* 为新设计的底部按钮预留更多空间 */
    padding: 0 16px;
  }

  .section-title {
    font-size: 22px;
    color: #6c757d !important;
    /* 强制应用标题色 */
    margin-bottom: 16px;
    padding-left: 8px;
  }

  .package-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
  }

  .package-card {
    position: relative;
    background-color: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    padding: 24px 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
    box-sizing: border-box;
  }

  .package-card.active {
    border-color: #007bff !important;
    background-color: #e6f7ff !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
  .package-card.active .package-title {
    color: #007bff !important;
    /* 强制应用激活标题色 */
  }
  .package-card.active .main-price {
    color: #e74c3c !important;
    /* 强制应用激活价格色 */
  }

  .original-price {
    margin-left: 5px;
    margin-right: 5px;
    text-decoration: line-through;
    color: #969799;
    font-size: 20px;
    transform: skew(-10deg);
    display: inline-block;
  }
  .package-title {
    font-size: 24px;
    color: #57616d !important;
    margin-bottom: 8px;
    font-weight: 500;
    line-height: 1.4;
  }

  .main-price-row {
    display: flex;
    justify-content: center;
    align-items: baseline;
    margin-top: 6px;
    margin-bottom: 4px;
  }

  .main-price {
    font-size: 24px;
    font-weight: bold;
    color: #57616d !important;
  }

  .sub-label {
    font-size: 12px;
    color: #999;
    margin-left: 4px;
  }

  .package-flow {
    font-size: 16px;
    color: #6c757d;
    margin-top: 12px;
  }

  .check-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #007bff;
    font-size: 16px;
    background-color: #ffffff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dee2e6;
  }

  /* ------------------- 重点修改：底部按钮区域样式 (强化版) ------------------- */
  .submit-area {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    /* 增加底部区域的整体内边距，给按钮留出呼吸空间 */
    padding: 16px 16px calc(16px + constant(safe-area-inset-bottom)) 16px;
    padding: 16px 16px calc(16px + env(safe-area-inset-bottom)) 16px;
    z-index: 10;
    background-color: #ffffff !important;
    /* 改为白色背景，更清晰 */
    /* 加强顶部边框，使其更明显 */
    border-top: 1px solid #e9ecef;
    /* 保留轻微的顶部阴影，区分层级 */
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }

  .submit-content {
    display: flex;
    flex-direction: column;
    /* 改为纵向排列 */
    align-items: stretch;
    /* 子元素拉伸以填充容器宽度 */
    gap: 12px;
    /* 价格和按钮之间的间距 */
  }

  .total-amount {
    display: flex;
    flex-direction: row;
    /* 价格信息本身横向排列 */
    align-items: baseline;
    /* 基线对齐，使 "¥" 和数字更好看 */
    justify-content: left;
    /* 居中显示 */
    gap: 4px;
    /* "实付" 和 "¥XX.XX" 之间的间距 */
  }

  .total-amount .label {
    font-weight: 500;
    font-size: 24px;
    /* 稍微增大标签字体 */
    color: #6c757d !important;
  }

  .total-amount .labelTwo {
    margin-left: 15px;
    font-size: 18px;
    .priceTwo {
      font-size: 18px;
      /* 显著增大价格字体 */
      color: #e74c3c !important;
      /* 强制应用价格色 */
      font-weight: 500;
    }
  }

  .total-amount .tips {
    font-size: 22px;
    /* 稍微增大标签字体 */
    color: #6c757d !important;
  }

  .total-amount .price {
    font-size: 24px;
    /* 显著增大价格字体 */
    color: #e74c3c !important;
    /* 强制应用价格色 */
    font-weight: 500;
  }

  /* --- 强化 CTA 按钮样式 --- */
  .recharge-button {
    /* 占据父容器全部宽度 */
    width: 100%;

    /* 显著增加按钮尺寸 */
    height: 75px;
    /* 比之前更大 */
    padding: 0 24px;
    /* 左右内边距 */

    /* 更大的圆角 */
    border-radius: 26px;
    /* 高度的一半，形成胶囊状 */

    /* 字体设置 */
    font-size: 32px;
    /* 更大的字体 */
    font-weight: 600;
    /* 更粗的字重 */
    letter-spacing: 1px;
    /* 微小字间距，提升质感 */

    /* 使用 Vant 主色调，但可以考虑加深一点饱和度或亮度以增强对比 */
    /* 注意：这里的颜色依赖于 Vant 的主题色配置 */

    /* 关键：更强的初始阴影 */
    box-shadow: 0 6px 16px -2px rgba(0, 123, 255, 0.4),
      /* 主投影 */
      0 4px 8px -2px rgba(0, 123, 255, 0.2);
    /* 辅助投影，增加深度 */

    /* 过渡效果，使交互更流畅 */
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    /* 确保内容垂直居中 */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* --- 按钮按下/聚焦状态 (强化反馈) --- */
  .recharge-button:active,
  .recharge-button:focus {
    /* 按下时，背景色稍微变深（如果使用的是 Vant 主题色，这会自动适配） */
    /* 或者你可以手动指定一个更深的颜色 */

    /* 模拟按下效果的关键：改变阴影 */
    box-shadow: 0 2px 8px -2px rgba(0, 123, 255, 0.3),
      /* 阴影变得更近、更模糊 */
      0 1px 4px -2px rgba(0, 123, 255, 0.15),
      inset 0 2px 4px rgba(0, 0, 0, 0.1);
    /* 内阴影，增加凹陷感 */

    /* 向下轻微位移，模拟被按下去的感觉 */
    transform: translateY(2px);

    /* 可选：轻微缩小 */
    /* transform: scale(0.98) translateY(1px); */
  }

  /* --- 按钮禁用状态 --- */
  .recharge-button:disabled {
    /* 降低透明度 */
    opacity: 0.5;
    /* 禁用所有变换和阴影效果 */
    transform: none;
    box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.1);
    /* 一个很淡的静态阴影 */
    /* 确保没有点击效果 */
    pointer-events: none;
    cursor: not-allowed;
  }

  /* -------------------------------------------------------------------- */

  /* --- 确保 Vant Cell Group 的 inset 样式 --- */
  ::v-deep .van-cell-group--inset {
    margin: 16px;
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    /* 按钮与分隔符之间的间距 */
    margin-top: 20px;
  }

  .recharge-button {
    flex: 1;
    /* 让按钮平分剩余空间 */
    max-width: calc(50% - 15px);
    /* 减去一半的 gap 空间 */
  }

  .separator {
    font-size: 16px;
    color: #666;
    white-space: nowrap;
  }

  /* 极度压缩高度，淡化视觉注意力 */
  .subtle-notice {
    height: 26px;
    /* 强制压缩高度，默认通常在 40px 左右 */
    padding: 0 10px;
    /* 减少左右内边距 */
    font-size: 12px;
    /* 缩小字体 */
    line-height: 26px;
    /* 行高与高度保持一致，确保文字垂直居中 */
    background-color: #fafafa;
    /* 使用极浅的灰色背景，或者直接设为 #fff 白色 */
    color: #969799;
    /* 使用浅灰色字体，降低视觉冲击力 */
  }

  /* 深度选择器：覆盖 Vant 内部文字区域的默认样式 */
  .subtle-notice :deep(.van-notice-bar__wrap),
  .subtle-notice :deep(.van-notice-bar__content) {
    height: 26px;
    line-height: 26px;
  }

  /* 使用 :deep() 深度选择器穿透到 vant 组件内部 */
  :deep(.subtle-notice .van-notice-bar__content) {
    display: inline-block !important;
    white-space: nowrap !important;
    padding-left: 100% !important;
    /* 保持从右侧优雅滚入的开场效果 */
    /* 这里的 15s 是滚动一圈的总时长，你可以根据文字长短微调 */
    animation: smooth-marquee 3s linear infinite !important;
  }

  /* 定义跑马灯动画 */
  @keyframes subtle-notice {
    0% {
      transform: translateX(0);
      /* 初始位置在容器最右侧外部 */
    }

    100% {
      transform: translateX(-100%);
      /* 完整滚出左侧，实现无缝衔接 */
    }
  }

  /deep/ .van-cell__value {
    max-width: 80%;
    flex: none;
  }

  // 预存支付
  /* 针对 van-popup 的自定义样式 */
  ::v-deep .password-popup {
    width: 75%;
    max-height: 80%;
    z-index: 2100 !important;
  }

  .password-dialog {
    padding: 20px;
    min-height: 500px;
    display: flex;
    flex-direction: column;
  }

  .title {
    margin: 10px 0 10px 0;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .description {
    margin: 0 0 20px 0;
    font-size: 20px;
    color: #666;
    line-height: 1.5;
    text-align: left;
  }

  .input-label {
    margin: 0 0 10px 0;
    font-size: 24px;
    color: #333;
  }

  /* 弹窗内提示样式 */
  .popup-toast {
    padding: 8px 12px;
    margin: 8px 0;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    animation: fadeInOut 3s ease-in-out;
  }

  .popup-toast.info {
    background-color: #e3f2fd;
    color: #1976d2;
  }

  .popup-toast.success {
    background-color: #e8f5e8;
    color: #388e3c;
  }

  .popup-toast.fail {
    background-color: #ffebee;
    color: #d32f2f;
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 1;
    }

    90% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  /* 自定义密码输入框样式 */
  .password-input-wrapper {
    margin: 0 35px 0 0;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #ebedf0;
    border-radius: 4px;
    padding: 8px 12px;
    background-color: white;
  }

  .custom-password-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 24px;
    padding: 0;
    background: transparent;
  }

  .custom-password-input::placeholder {
    color: #c8c9cc;
  }

  .toggle-password-icon {
    margin-left: 8px;
    font-size: 18px;
    color: #969799;
    cursor: pointer;
  }

  .actions {
    margin-top: auto;
    display: flex;
    gap: 10px;
  }

  .actions .van-button {
    flex: 1;
  }
</style>
